export default __webpack_public_path__ + "a7cf0226d7e2039499fa3fe15c44b5b5.svg";